import { useSyncExternalStore } from "react";

/**
 * One clock for the whole dashboard, ticking once a second.
 *
 * The red prep timer (admin#40) shows a live countdown in every waiting row. A
 * `setInterval` per row would start one timer per cell and drift them apart.
 * Here there is exactly one interval, started by the first reader and stopped
 * when the last one goes away, and every reader sees the same second.
 */
let now = Date.now();
const listeners = new Set();
let interval = null;

const subscribe = (listener) => {
    listeners.add(listener);
    if (interval === null) {
        now = Date.now();
        interval = setInterval(() => {
            now = Date.now();
            listeners.forEach((notify) => notify());
        }, 1000);
    }
    return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
            clearInterval(interval);
            interval = null;
        }
    };
};

const getSnapshot = () => now;

/** The current time in ms, updated once a second for as long as it is read. */
const useNow = () => useSyncExternalStore(subscribe, getSnapshot);

export default useNow;
